import Updater from './Updater';
import * as is from '../../Misc/is';
import { UI } from 'StateEvents';
import { isMobile } from 'Misc/environment';
import { getInstance } from '../StateManager';

export default class DisplayUpdater extends Updater {
  constructor() {
    super();
    this.addRelevant(UI);
  }

  updateState(newState, event) {
    switch(event.name) {
      case UI.SKIPPED:
        newState.display.skips += 1;
        break;
      case UI.CLICKED:
        newState.display.clicks += 1;
        break;
      case UI.SHARED:
        newState.display.shares = newState.display.shares.concat(event.args);
        break;
      case UI.HOVERED:
        newState.display.hover = event.args || isMobile;
        break;
      case UI.PLAYED:
        newState.media.paused = false;
        break;
    }

    return newState;
  }
}

getInstance().registerUpdater(new DisplayUpdater());


// WEBPACK FOOTER //
// ./src/Services/State/Updaters/DisplayUpdater.js